/**
 * THIS FILE IS AUTOGENERATED PARTIALLY
 * DO NOT EDIT THE APP VERSION OR RELEASE DATE
 * IF YOU CHANGE ANY KEY NAME BE SURE TO REFLECT THIS CHANGE IN OUR AUTOMATION SCRIPT
 */
import { Version, version as libVersion } from '@igo2/core/config';

export const version: Version = {
  ...libVersion,
  app: '20.1.2',
  releaseDateApp: 1781703865441
};
